import React from 'react';
import CurrencyFormat from 'react-currency-format';

import './MaskedInput.scss';

const MaskedInput = ({
  value,
  decimals = 2,
  displayType,
  className,
  placeholder,
  onValueChange,
  isAllowed,
  onChange,
  format,
  mask,
  onBlur,
  id,
  name,
}) => (
  <CurrencyFormat
    value={value}
    className={className}
    placeholder={placeholder}
    onValueChange={onValueChange}
    format={format}
    mask={mask}
    onBlur={onBlur}
    id={id}
    name={name}
    onChange={onChange}
  />
);
MaskedInput.defaultProps = {
  isAllowed: () => true,
  onBlur: () => {},
};

export default MaskedInput;
